import "prismjs";
import "./prism-jsx";
import "./prism-typescript";
import "prismjs/components/prism-tsx";
